<template>
  <div class="branch__content">
    <div class="branch__form">
      <vs-button color="primary" type="flat" @click="popupActive = true"
        >+ Add Branch</vs-button
      >
      <vs-popup
        @close="closePopupHandle"
        classContent="branch__popup"
        title="Add branch"
        :active.sync="popupActive"
      >
        <BranchesForm
          v-if="popupActive"
          :branch="selectedBranch"
          @closePopup="closePopup"
        />
      </vs-popup>
    </div>
    <vs-list>
      <vs-list-item
        v-for="branch in branches"
        :key="branch.id"
        icon="home"
        :title="branch.name"
        :subtitle="`${branch.prefix || '-'} | Created: ${$moment(branch.created*1000).format('YY-MM-DD')}`"
      >
        <vs-button
          :data-id="branch.id"
          radius
          color="dark"
          icon="edit"
          type="flat"
          title="Edit branch"
          @click="editBranch(branch.id)"
        ></vs-button>

        <vs-button
          :data-id="branch.id"
          radius
          color="dark"
          icon="delete"
          type="flat"
          title="Delete branch"
          @click="deleteBranch"
        ></vs-button>
      </vs-list-item>
    </vs-list>
    
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import BranchesForm from '@/components/settings/branchesForm'

export default {
  name: 'Branches',
  data() {
    return {
      selectedBranch: {},
      popupActive: false,
    }
  },
  components: {
    BranchesForm,
  },
  computed: {
    ...mapState({
      branches: state => state.branches.branches,
    }),
  },
  methods: {
    editBranch: function(branchId) {
      this.selectedBranch = this.branches.find(r => r.id == branchId)
      this.popupActive = true
    },
    deleteBranch: function(e) {
      this.selectedBranch = this.branches.find(
        r => r.id == e.target.parentElement.dataset.id
      )

      this.openAlert()
    },
    openAlert: function () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Delete branch',
        text: 'Are you sure you want to delete the branch?',
        accept: this.acceptAlert,
      })
    },
    acceptAlert: function () {
      this.$store
        .dispatch('branches/deleteBranchAction', this.selectedBranch.id)
        .then(() => {
          this.$vs.notify({
            title: 'Removed',
            text: `Branch ${this.selectedBranch.name} removed`,
            color: 'success',
            position: 'top-right',
          })
          this.selectedBranch = {}
        })
        .catch(r => {
          this.$vs.notify({
            title: 'Remove Error',
            text: r.message,
            color: 'danger',
            position: 'top-right',
          })
          this.selectedBranch = {}
        })
      this.popupActive = false
    },
    closePopup: function() {
      this.popupActive = false
      this.selectedBranch = {}
    },
    closePopupHandle: function() {
      this.selectedBranch = {}
    },
  },
}
</script>
<style lang="scss">
.branch__content {
  max-width: 500px;
}
</style>
